import { KeyValue } from '@/main/models/common';
import React, { useState } from 'react';


import { Button, Checkbox, FormControlLabel, Modal } from '@mui/material';
import KogModalFadeComponent from '@/main/components/modal/ModalFadeComponent';
import * as S from './styles';
import { getTranslateByKey } from '@/main/services/utils';
import { FieldError, useFormContext } from 'react-hook-form';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import { Guid } from 'guid-typescript';

interface IBodyshopAssignationModalProps {
  dataAssignableBodyshop: KeyValue[];
  setGuidAssignedBodyShop: (value: string | null) => void;
  handleBodyshopAssignment: (value: string | null) => void;
  open: boolean;
  rfc: string;
}

function BodyshopAssignationModal({
  dataAssignableBodyshop,
  setGuidAssignedBodyShop,
  open,
  handleBodyshopAssignment,
  rfc
}: IBodyshopAssignationModalProps) {
  const {
    formState: { errors }
  } = useFormContext();
  const [selectedBodyshop, setSelectedBodyshop] = useState<string | null>(null);

  const bodyshopOptions = dataAssignableBodyshop.map((item) => {
    const key = item.key as string;
    return (
      <FormControlLabel
        key={key}
        label={`${item.value} - ${rfc} `}
        id={`select-bodyshop-assignation-option-${key}`}
        control={
          <Checkbox
            color="primary"
            checked={selectedBodyshop === key}
            onChange={e => setSelectedBodyshop(item.key as string)}
            name={item.value}
          />
        }
      />
    );
  });

  const modalContent = (
    <S.ContainerModalConfirmation>
      <p>{getTranslateByKey('information.linkSupplierToBodyshopPrompt')}</p>
      <S.ColumnCheckbox>{bodyshopOptions}</S.ColumnCheckbox>
      <S.AreaButtons>
        <SecondaryButton
          type="button"
          onClick={() => {
            setGuidAssignedBodyShop(Guid.EMPTY);
            errors.rfc = {message: getTranslateByKey('information.registrationNumberAlreadyInUse', true), type: 'error'} as FieldError;
          }}
          id="id-configmBodyshopAssignment-button-no">
          {getTranslateByKey('information.no')}
        </SecondaryButton>
        <SecondaryButton
          id="id-configmBodyshopAssignment-button-yes"
          type="button"
          onClick={() => handleBodyshopAssignment(selectedBodyshop)}>
          {getTranslateByKey('information.yes')}
        </SecondaryButton>
      </S.AreaButtons>
    </S.ContainerModalConfirmation>
  );

  return (
    <KogModalFadeComponent open={open}>
      {modalContent}
    </KogModalFadeComponent>
  );
}

export default BodyshopAssignationModal;
